<template>
	<div>
		<div class="wrapper">
			<div class="subscribe-form">
				<div class="subscribe-form_ico">
					<img src="/img/ico-phone.svg" width="55" alt="">
				</div>
				<div class="subscribe-form_text">
					{{$t('Вы не подписаны, подпишитесь')}}

					<b>{{$t('Команда подключения')}}:</b>
					<div class="info">
						<i>
							<span class="icons"> </span>
						</i>
						<span class="icons">*4546#</span>
						<span class="icons icons--phone"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				auth: window.auth,
			}
		},

		created() {
			if (!this.auth.msisdn) {
				this.$router.push({
					name: 'login'
				});
				return;
			}
			
			if (this.auth.subscribtion) {
				this.$router.push({
					name: 'home'
				})
			}
		},

		methods: {
			
		},
	}
</script>

<style scoped>

</style>
